import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController } from 'ionic-angular';

/**
 * Generated class for the PagesPromoInfoPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'ages-promo-info',
  templateUrl: 'promo-info.html',
})
export class PromoInfoPage {

  constructor(
    public viewCtrl: ViewController,
    public navCtrl: NavController,
    public navParams: NavParams
  ) {}
  closePopover() {
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/pages/promo-info/promo-info.ts